import type { AdToken } from "@/shared/adTokens/adTokens";
import { httpRequest } from "../../http";

/**
 * The ad tokens a copywriter may legally put in an ad's text (MPN-1928).
 *
 * Global reference data, the same vocabulary for every organization, curated by hand in
 * Django admin -- so the picker reads it once per page load and filters in memory. There is
 * nothing to pass and nothing to paginate.
 */
export class CommandListAdTokens {
  async run(): Promise<AdToken[]> {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ad-tokens/`;

    try {
      const response = await httpRequest<AdToken[]>(url, { method: "GET" });
      return Array.isArray(response) ? response : [];
    } catch (error) {
      console.error("Error fetching ad tokens:", error);
      throw error;
    }
  }
}
